function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "40",
  height: "40",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "prefix__a",
  width: "187.5%",
  height: "187.5%",
  x: "-43.8%",
  y: "-31.2%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: "5",
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: "5"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
})), /*#__PURE__*/React.createElement("circle", {
  id: "prefix__b",
  cx: "20",
  cy: "20",
  r: "20"
})), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  xlinkHref: "#prefix__b",
  id: "menubutton"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#353535",
  xlinkHref: "#prefix__b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.478 23c.288 0 .522.224.522.5 0 .245-.185.45-.428.492l-.094.008H14.522a.512.512 0 01-.522-.5c0-.245.185-.45.428-.492l.094-.008h10.956zm0-4c.288 0 .522.224.522.5 0 .245-.185.45-.428.492l-.094.008H14.522a.512.512 0 01-.522-.5c0-.245.185-.45.428-.492l.094-.008h10.956zm0-4c.288 0 .522.224.522.5 0 .245-.185.45-.428.492l-.094.008H14.522a.512.512 0 01-.522-.5c0-.245.185-.45.428-.492l.094-.008h10.956z",
  fill: "#FFF"
}))));